<template>
  <div>
    <send-delayed-verification></send-delayed-verification>
  </div>
</template>

<script>
var getters = require('common/store/getters')
module.exports = {
  components: {
    sendDelayedVerification: require('c/components/SendDelayedVerification')
  },
  vuex: {
    getters: getters
  }
}

</script>




// WEBPACK FOOTER //
// UserPending.vue?79fc0f39